import styled from "styled-components";
import {
  siteDarkBlue,
  sitePurple,
  siteLightBlue,
  siteDarkGreen
} from "../../providers/Theme";

export const Section = styled.section`
  background: white;
  padding: 4rem 1.5rem;
`;

export const SectionHeading = styled.h2`
  color: ${siteDarkBlue};
  font-weight: 800;
  font-size: 2rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  text-align: center;
  margin-bottom: 3rem;

  ${({ theme }) => theme.md`
    font-size: 2.5rem;
  `}
`;

export const PillarsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2.5rem;
  max-width: 72rem;
  margin: 0 auto;

  ${({ theme }) => theme.sm`
    grid-template-columns: 1fr 1fr;
  `}

  ${({ theme }) => theme.lg`
    grid-template-columns: repeat(4, 1fr);
  `}
`;

export const Pillar = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PillarHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

export const PillarIcon = styled.div<{ color: string }>`
  width: 5rem;
  height: 5rem;
  flex-shrink: 0;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const PillarTitle = styled.h3<{ color: string }>`
  color: ${({ color }) => color};
  font-weight: 800;
  font-size: 1.3rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin: 0;
`;

export const PillarBody = styled.p`
  color: ${siteDarkBlue};
  font-size: 1.5rem;
  line-height: 1.6;
  flex: 1;
  margin-bottom: 1.25rem;
`;

export const PillarLink = styled.button<{ color: string }>`
  background: none;
  border: none;
  padding: 0;
  color: ${({ color }) => color};
  font-weight: 600;
  font-size: 1.15rem;
  cursor: pointer;
  text-align: left;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;

  &:hover {
    text-decoration: underline;
  }
`;

export const pillarColors = {
  blue: siteLightBlue,
  purple: sitePurple,
  green: siteDarkGreen,
  darkBlue: siteDarkBlue
};
